<template>
    <div class="form-group form-switch">
        <toggle-button v-model="isChecked" :sync="true" :width="width" :disabled="disabled" :height="height" color="rgb(121, 189, 143)" @change="updateValue" :labels="placeholder"/>
        <label class="label" v-if="label" v-text="label"></label>
    </div>
</template>
<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        props: {
            width: {
                type: Number,
                required: false,
                default: 100,
            },
            height: {
                type: Number,
                required: false,
                default: 30,
            },
            label: {
                type: String,
                required: false,
                default: '',
            }
        },

        data() {
            return {
                isChecked: this.value
            }
        },

        methods: {
            updateValue(event) {
                this.$emit('input', event.value);
                this.$emit('change', event.value);
            }
        },
    }
</script>